import { Link, Typography } from '@mui/material';
import { blue, green, grey } from '@mui/material/colors';
import { Box } from '@mui/system';
import dayjs from 'dayjs';
import React from 'react';
import { PATH } from '../../../../config/path';
import { Link as ReactRouterLink } from 'react-router-dom';

const BookingCard = (props) => {
  const { order } = props;

  return (
    <Box
      sx={{
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
        borderRadius: 2,
      }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2,
          backgroundColor: grey[200],
          py: 2,
          px: {
            xs: 2,
            md: 3,
          },
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
        }}>
        <Typography
          variant="body1"
          sx={{
            maxWidth: {
              xs: '100%',
              md: '50%',
            },
          }}>
          {order?.product_name}
        </Typography>
        <Typography variant="body1">
          Booking ID: <b>{order?.booking_id}</b>
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: {
            xs: 4,
            md: 12,
          },
          color: grey[600],
          py: 2,
          px: {
            xs: 2,
            md: 3,
          },
        }}>
        <Box>
          <Typography
            variant="body1"
            mb={0.5}
            sx={{
              fontSize: {
                xs: '0.75rem',
                md: '1rem',
              },
            }}>
            START DATE
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: {
                xs: '0.75rem',
                md: '1rem',
              },
            }}>
            {dayjs(order?.start_date).format('DD MMM YYYY')}
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="body1"
            mb={0.5}
            sx={{
              fontSize: {
                xs: '0.75rem',
                md: '1rem',
              },
            }}>
            END DATE
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: {
                xs: '0.75rem',
                md: '1rem',
              },
            }}>
            {dayjs(order?.end_date).format('DD MMM YYYY')}
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="body1"
            mb={0.5}
            sx={{
              fontSize: {
                xs: '0.75rem',
                md: '1rem',
              },
            }}>
            DESTINATION
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: {
                xs: '0.75rem',
                md: '1rem',
              },
            }}>
            {order?.destination}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2,
          backgroundColor: grey[200],
          py: 2,
          pb: 3,
          px: {
            xs: 2,
            md: 3,
          },
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: green[600],
            borderRadius: 5,
            py: 0.2,
            px: 2,
          }}>
          <Typography
            variant="body1"
            color="white"
            py={0.2}
            sx={{
              fontSize: {
                xs: '0.75rem',
                md: '0.875rem',
              },
            }}>
            {order?.ticket_status}
          </Typography>
        </Box>
        <Link
          component={ReactRouterLink}
          to={`${PATH.BOOKING_DETAILS}/${order?.order_id}`}
          underline="hover"
          color={blue[600]}>
          <Typography variant="body1" noWrap>
            See Details
          </Typography>
        </Link>
      </Box>
    </Box>
  );
};

export default BookingCard;
